import { Component, OnInit } from '@angular/core';
import { FilteredListConfig, FilteredListItem, Badge } from '@appcatalyst/ng-cms-core-lib';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.scss']
})
export class SpecialtiesComponent implements OnInit {
  specialties$: Observable<any>
  private specialties: any[]
  params: any
  
  constructor(
    private config: FilteredListConfig,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.params = {...params}
    })
    this.route.data.subscribe((data: {specialties: any}) => {
      this.specialties$ = data.specialties
      this.specialties = data.specialties
      this.config.listItems = this.specialties.map(specialty => {
        return {
          _id: null,
          title: specialty.description,
        }
      });
      this.config.count = this.specialties.length
      this.config.page = 1
      this.config.limit = this.specialties.length
      this.config.emitChanges()
    })
    this.config.title = 'Specialties'
  }
}
